import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';

import { decodeHtmlEntities } from '../../helpers/decodeHtmlEntities';
import c from './_profileAddress.module.scss';

export interface ProfileAddressProps {
  addr1: string | null;
  addr2: string | null;
  city: string | null;
  region: string | null;
  state: string | null;
  country?: string | null;
  zip: string | null;
}

export function ProfileAddress({ addr1, addr2, city, region, state, country, zip }: ProfileAddressProps) {
  const lines = [addr1, addr2, city, region, state, country, zip].filter((line): line is string => {
    return Boolean(line);
  });

  if (lines.length === 0) return null;

  return (
    <div className={clsx('profile-address', c.wrapper)}>
      <div className={clsx('profile-address__title', c.title)}>
        <FontAwesomeIcon icon={['fas', 'map-marker-alt']} /> {i18n.translate('directoryProfileView.address')}
      </div>
      <p>
        {lines.map((line, index) => {
          return (
            <React.Fragment key={index}>
              {decodeHtmlEntities(line)}
              <br />
            </React.Fragment>
          );
        })}
      </p>
    </div>
  );
}
